import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const LightbulbIcon: FunctionComponent = () => <MaterialUiIcons.EmojiObjects />;

export default LightbulbIcon;
